import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreOrgStructureItem as apiFn } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreOrgStructureItem() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreOrgStructureItem, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureItems"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { restoreOrgStructureItem, isRestore };
}
